import { render, staticRenderFns } from "./NumeratoriEditPage.vue?vue&type=template&id=085d6145&scoped=true"
import script from "./NumeratoriEditPage.vue?vue&type=script&lang=js"
export * from "./NumeratoriEditPage.vue?vue&type=script&lang=js"
import style0 from "./NumeratoriEditPage.vue?vue&type=style&index=0&id=085d6145&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085d6145",
  null
  
)

export default component.exports